import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { CataloguePageHeader } from '@/components/catalogue/Header';
import { AllProducts } from '@/components/catalogue/products/AllProducts';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { UserGuideButton } from '@/components/guide/UserGuideButton';
import { Loading } from '@/components/loading/Loading';
import { useSelectedProducts } from '@/services/catalogue/useCustomerCatalogueService';
import { useNavigateAndValidate } from '@/services/catalogue/validation/catalogueHooks';
import { useCustomerRoutePrefix } from '@/services/customer/useCustomerRoutePrefix';
import { FC, Suspense } from 'react';
import { CustomerCatalogueContainer } from '../CustomerCatalogueContainer';

const CustomerSelectedProducts: FC = () => {
  const routePrefix = useCustomerRoutePrefix();

  const breadcrumbs: NavPage[] = [
    {
      name: 'Standardise Products',
      to: `${routePrefix}/standardise/selectedProducts`
    },
    {
      name: 'Selected Products',
      to: ''
    }
  ];

  const navigateAndValidate = useNavigateAndValidate();

  const selectedProducts = useSelectedProducts();
  const selectedProductIds = selectedProducts.map(p => p.id);

  return (
    <div className="flex flex-1 flex-col bg-white bg-opacity-50">
      <CataloguePageHeader title="Standardise Products" subtitle={'Selected Products'} breadcrumbs={breadcrumbs}>
        <div className="flex gap-4">
          <UserGuideButton newRoute={`${routePrefix}/standardise/guide`} />
          <Button onClick={() => navigateAndValidate(`${routePrefix}/catalogue`)} variant={ButtonVariant.Secondary}>
            <span>Add more products</span>
          </Button>
          <Button variant={ButtonVariant.Primary} onClick={() => navigateAndValidate(`${routePrefix}/bundles`)}>
            Create Bundles
          </Button>
        </div>
      </CataloguePageHeader>
      <div className="overflow-y-auto py-8">
        {selectedProductIds.length > 0 ? (
          <AllProducts filterProductIds={selectedProductIds} />
        ) : (
          <div className="px-10 space-y-5">
            <p>Your standardised product list does not contain any main devices.</p>
            <p>Please return to the catalogue and select at least one main device.</p>
            <Button onClick={() => navigateAndValidate(`${routePrefix}/catalogue`)} variant={ButtonVariant.Primary}>
              <span>Return to the Catalogue</span>
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export const CustomerSelectedProductsPage: FC = () => {
  return (
    <CustomerCatalogueContainer>
      <div className="flex w-full">
        <Suspense fallback={<Loading className="h-screen" />}>
          <CustomerSelectedProducts />
        </Suspense>
      </div>
    </CustomerCatalogueContainer>
  );
};
